import React from 'react';
import { ControlLabel, FormGroup, HelpBlock } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../content/utils.js';
import { CloseIcon } from '../../icons/CloseIcon.jsx';
import OwnersSelect from './OwnersSelect.jsx';

const blockStyle = {
  border: '1px solid #DFE2E5',
  borderRadius: '3px',
};

const closeBtnStyle = {
  padding: '4px',
  lineHeight: '12px',
  background: 'none',
};

const ownerItemStyle = {
  paddingLeft: '4px',
  background: '#F7FAFD',
  border: '1px solid #DFE2E5',
  borderRadius: '3px',
};

function ProjectOwners(props) {
  const {
    projectOwners,
    selectedOwnerIds,
    updateSelectedOwnerIds,
    meta,
    disabled,
  } = props;

  const hasError = meta.touched && (meta.error || meta.submitError);

  const handleSelect = (id, showNotify) => {
    const isExist = selectedOwnerIds.includes(id);

    if (
      isExist &&
      showNotify &&
      !window.confirm('Are you sure you want to detach this owner?')
    )
      return;

    isExist &&
      updateSelectedOwnerIds(selectedOwnerIds.filter((item) => item !== id));
    !isExist && updateSelectedOwnerIds([...selectedOwnerIds, id]);
  };

  const renderOwnerItem = (id) => {
    const owner = projectOwners.find((owner) => owner.id === id);
    const name = owner ? owner.fullName : '';
    const isArchived = owner ? owner.archived : false;
    return (
      <div key={id} className="flex m-t-4 m-l-4" style={ownerItemStyle}>
        {isArchived ? `${name} (archived)` : name}
        <span
          className="btn btn-clear"
          style={closeBtnStyle}
          onClick={() => {
            if (!disabled) {
              handleSelect(id, true);
            }
          }}
        >
          <CloseIcon />
        </span>
      </div>
    );
  };

  return (
    <FormGroup validationState={hasError ? 'error' : null}>
      <ControlLabel>{getOrgTermsContent('projectLabels.owners')}</ControlLabel>
      <div style={blockStyle}>
        <div
          className="flex flex-align-start flex-wrap"
          style={disabled ? { background: '#eeeeee' } : {}}
        >
          {selectedOwnerIds.map(renderOwnerItem)}
        </div>
        <OwnersSelect
          {...props}
          disabled={disabled}
          handleSelect={handleSelect}
        />
      </div>
      {hasError && <HelpBlock>{meta.error || meta.submitError}</HelpBlock>}
    </FormGroup>
  );
}
export default ProjectOwners;
